import { render, staticRenderFns } from "./VehicleIssuanceRecordCreate.vue?vue&type=template&id=1d46461d&scoped=true&"
import script from "./VehicleIssuanceRecordCreate.vue?vue&type=script&lang=js&"
export * from "./VehicleIssuanceRecordCreate.vue?vue&type=script&lang=js&"
import style0 from "./VehicleIssuanceRecordCreate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VehicleIssuanceRecordCreate.vue?vue&type=style&index=1&id=1d46461d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d46461d",
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QItemSection,QBtn,QCardActions,QSelect,QIcon,QList,QItemLabel,QBadge,QChip,QExpansionItem,QInput,QInnerLoading,QSpinnerGears,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QItemSection,QBtn,QCardActions,QSelect,QIcon,QList,QItemLabel,QBadge,QChip,QExpansionItem,QInput,QInnerLoading,QSpinnerGears}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
